import React from 'react'

const CareerRequest = () => {
  return (
    <div>
      
    </div>
  )
}

export default CareerRequest
